import React, { useState } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import BookInventory from './BookInventory';
import BookCirculation from './BookCirculation';
import MemberManagement from './MemberManagement';
import FineManagement from './FineManagement';

interface LibraryModuleProps {
  domain: string;
  onBack: () => void;
}

const LibraryModule: React.FC<LibraryModuleProps> = ({ domain, onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>('inventory');

  React.useEffect(() => {
    const path = location.pathname;
    if (path.includes('/circulation')) setActiveTab('circulation');
    else if (path.includes('/members')) setActiveTab('members');
    else if (path.includes('/fines')) setActiveTab('fines');
    else setActiveTab('inventory');
  }, [location.pathname]);

  return (
    <div className="min-vh-100 bg-light">
      {/* Header */}
      <div className="bg-primary-custom text-white p-3 shadow-sm">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <h4 className="mb-0">
            <i className="bi bi-journal-bookmark me-2"></i>
            Library Management
          </h4>
          <button className="btn btn-light btn-sm" onClick={onBack}>
            <i className="bi bi-arrow-left me-2"></i>
            Back to Dashboard
          </button>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white shadow-sm">
        <div className="container-fluid">
          <ul className="nav nav-tabs border-0">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'inventory' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/library')}
              >
                <i className="bi bi-book me-2"></i>
                Book Inventory
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'circulation' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/library/circulation')}
              >
                <i className="bi bi-arrow-left-right me-2"></i>
                Issue / Return
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'members' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/library/members')}
              >
                <i className="bi bi-people me-2"></i>
                Members
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'fines' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/library/fines')}
              >
                <i className="bi bi-cash-coin me-2"></i>
                Fines & Dues
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Content Area */}
      <div className="container-fluid py-4">
        <Routes>
          <Route index element={<BookInventory domain={domain} />} />
          <Route path="circulation" element={<BookCirculation domain={domain} />} />
          <Route path="members" element={<MemberManagement domain={domain} />} />
          <Route path="fines" element={<FineManagement domain={domain} />} />
        </Routes>
      </div>
    </div>
  );
};

export default LibraryModule;
